var map = {
	"./icons/blog.png": [
		24,
		40
	],
	"./icons/blog2.svg": [
		25,
		0
	],
	"./icons/discord.svg": [
		26,
		1
	],
	"./icons/docker.svg": [
		27,
		2
	],
	"./icons/email.svg": [
		28,
		3
	],
	"./icons/email_alt.svg": [
		29,
		4
	],
	"./icons/facebook.svg": [
		30,
		5
	],
	"./icons/figma.svg": [
		31,
		6
	],
	"./icons/github.svg": [
		32,
		7
	],
	"./icons/gmeet.svg": [
		33,
		8
	],
	"./icons/goodreads.svg": [
		34,
		9
	],
	"./icons/harsh.png": [
		35,
		41
	],
	"./icons/harshAvatar.png": [
		36,
		42
	],
	"./icons/harshIcon.png": [
		37,
		43
	],
	"./icons/harshblog.png": [
		38,
		44
	],
	"./icons/instagram.svg": [
		39,
		10
	],
	"./icons/kit.svg": [
		40,
		11
	],
	"./icons/letterboxd.svg": [
		41,
		12
	],
	"./icons/linkedin.svg": [
		42,
		13
	],
	"./icons/mastodon.svg": [
		43,
		14
	],
	"./icons/medium.svg": [
		44,
		15
	],
	"./icons/messenger.svg": [
		45,
		16
	],
	"./icons/microblog.svg": [
		46,
		17
	],
	"./icons/pinterest.svg": [
		47,
		18
	],
	"./icons/producthunt.svg": [
		48,
		19
	],
	"./icons/reddit.svg": [
		49,
		20
	],
	"./icons/resume.svg": [
		50,
		21
	],
	"./icons/skoob.svg": [
		51,
		22
	],
	"./icons/slack.svg": [
		52,
		23
	],
	"./icons/snapchat.svg": [
		53,
		24
	],
	"./icons/soundcloud.svg": [
		54,
		25
	],
	"./icons/spotify.svg": [
		55,
		26
	],
	"./icons/steam.svg": [
		56,
		27
	],
	"./icons/strava.svg": [
		57,
		28
	],
	"./icons/telegram.svg": [
		58,
		29
	],
	"./icons/texam.png": [
		59,
		45
	],
	"./icons/tiktok.svg": [
		60,
		30
	],
	"./icons/trophy.svg": [
		61,
		31
	],
	"./icons/tumblr.svg": [
		62,
		32
	],
	"./icons/twitch.svg": [
		63,
		33
	],
	"./icons/twitter.svg": [
		64,
		34
	],
	"./icons/vimeo.svg": [
		65,
		35
	],
	"./icons/web.png": [
		66,
		46
	],
	"./icons/whatsapp.svg": [
		67,
		36
	],
	"./icons/wordpress.svg": [
		68,
		37
	],
	"./icons/youtube.svg": [
		69,
		38
	],
	"./icons/zoom.svg": [
		70,
		39
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 84;
module.exports = webpackAsyncContext;